// extracted by mini-css-extract-plugin
export default {"container":"mONDeUSJ","card":"xoIw_LMH","form":"JFkBdZj4","link":"Fvi1fsTa","list":"Gjb6mrDb","caption":"npnu89q0","caption_done":"H44m7mKd"};